import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 9.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z M8 13c2.25 0 4.905-1.62 6.507-4.13a1.616 1.616 0 0 0 0-1.74C12.905 4.62 10.25 3 8 3S3.095 4.62 1.493 7.13a1.615 1.615 0 0 0 0 1.74C3.095 11.38 5.75 13 8 13ZM5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z';
const draw24px =
  'M22.74,11.84a.43.43,0,0,0,0-.05C22.34,10,17.34,5.07,12,5.07s-10.42,5-10.73,6.77a.88.88,0,0,0,0,.16,1,1,0,0,0,0,.16c.3,1.71,5.27,6.68,10.58,6.76h.3c5.32-.08,10.28-5.05,10.58-6.76a.65.65,0,0,0,0-.32ZM12,16.38A4.38,4.38,0,1,1,16.39,12,4.39,4.39,0,0,1,12,16.38ZM14.25,12A2.25,2.25,0,1,1,12,9.75,2.25,2.25,0,0,1,14.25,12Z';
const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const EyeFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'eyeFilled'),
) as IconWithRender;

EyeFilledIcon.displayName = 'EyeFilledIcon';
EyeFilledIcon.propTypes = Icon.propTypes;
EyeFilledIcon.renderIcon = (props) => <EyeFilledIcon {...props} />;
export default EyeFilledIcon;
